<template>
  <div class="body">
    <!--TODO :key에 실시간 변화 감지 값 필요  -->
    <app-header />
    <router-view name="bodyContent"> </router-view>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader'
import AppFooter from '@/components/layout/AppFooter'
export default {
  name: 'MainLayout',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      componentKey: 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      
    }
  },
}
</script>

<style lang="less" scope src="@/assets/css/common.less"> </style>